


























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {UserStore} from '@/store/user-module';
import {successButtonColorClass} from '@/utlitities/color';

@Component({
  inheritAttrs: false,
})
export default class StDecimalInput extends Vue {
  @Prop() label!: string;
  @Prop() name!: string;
  @Prop() rules!: string;
  @Prop() value!: any;
  @Prop() inputClass!: string;
  @Prop() valImmediate!: boolean;
  @Prop() focus!: boolean;
  @Prop() disabled!: boolean;
  @Prop() addonText!: string;

  mounted() {
    if (this.focus) (this.$refs.inputfield as HTMLInputElement).focus();
  }

  get successButtonColor(){
    return successButtonColorClass(UserStore.userSettings.successButtonColor)
  }

  get decimalValue() {
    if (this.value != 0 && (!this.value || !this.value.toFixed)) {
      return this.value;
    }

    return this.value
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  @Emit('input')
  inputCurrency(event: any) {
    this.$forceUpdate();

    let val = event.target.value;
    val = val.replaceAll('.', '');
    val = val.replace(',', '.');

    if (!parseFloat(val)) {
      return 0;
    }
    return parseFloat(val);
  }

  @Emit('input')
  input(event: any) {
    return event.currentTarget.value;
  }
}
